module.exports = __webpack_public_path__ + "static/3-dd7796a12559b1292d4fbc1dfdf9bf9d.png";